import React from 'react';
import { BookAMeetingPageType } from '../../../lib/api/custom-page.types';
import { BookAMeetingPageWrapper } from '../BookAMeetingWrapper/BookAMeetingPageWrapper';

export const BookAMeetingCustomPage: React.FunctionComponent<BookAMeetingPageType> = (props: BookAMeetingPageType): JSX.Element | null => {
  if (props && Object.keys(props).length > 0) return <BookAMeetingPageWrapper {...props} />;
  return null;
};
